// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"ac809f26","138":"f529fc65","143":"4d4b6d57","359":"7dabcccf","591":"27b53cef","620":"6246e3d7","997":"c24ebd95"}[chunkId] + ".chunk.js";
};